import { createSlice } from '@reduxjs/toolkit';

import { getBimehNamehMadaniDetail } from 'Feature/Asansour/Estelam/Actions/action';

import { IBimehNamehMadaniDetailState } from './model';

const initialState: IBimehNamehMadaniDetailState = {
  loading: false,
  data: null,
};

export const BimehNamehMadaniDetailSlice = createSlice({
  name: 'Madani/BimehNamehDetail',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBimehNamehMadaniDetail.pending, (state) => {
        state.loading = true;
        state.data = initialState.data;
      })
      .addCase(getBimehNamehMadaniDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getBimehNamehMadaniDetail.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default BimehNamehMadaniDetailSlice.reducer;
